import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ErweiterungConfigResponse } from '../core/base-api';
import { SecurityData } from './security-data';
import { AppFormatConfigService } from '../core/services/app-format-config.service';
import ActiveErweiterungenEnum = ErweiterungConfigResponse.ActiveErweiterungenEnum;

export const canActivateErweiterung: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean> | Promise<boolean> | boolean => {
  return new Promise<boolean>((resolve) => {
    const erweiterung: ActiveErweiterungenEnum[] = route.data.erweiterung;
    const formatConfigService = inject(AppFormatConfigService);
    if (
      erweiterung &&
      !erweiterung.some((e) =>
        formatConfigService.erweiterungsConfig$.subscribe((data) => {
          if (data && !!data.activeErweiterungen) {
            return data.activeErweiterungen.includes(e);
          }
        })
      )
    ) {
      const securityData = inject(SecurityData);
      const router = inject(Router);
      securityData.actionUrl = state.url;
      securityData.erweiterung = erweiterung;
      router.navigate(['security/unsupported']);
      resolve(false);
    }
    resolve(true);
  });
};
